<i18n>
[
    "reviews__fitGuidanceSlider--headerPartOne",
    "reviews__fitGuidanceSlider--headerPartTwo",
    "reviews__fitGuidanceSlider--likeYouLegend",
    "reviews__fitGuidanceSlider--allLegend",
]
</i18n>

<template>
    <div v-if="reviewSummary?.fitRatingCount" class="c-product-fit-slider-scale">
        <p class="u-spacer--1pt5 o-text--caption">
            {{ t('reviews__fitGuidanceSlider--headerPartOne') }}
            <span class="u-text--gray">
                {{ t('reviews__fitGuidanceSlider--headerPartTwo') }}
            </span>
        </p>

        <BarGraph
            :ratingAverage="reviewSummary?.fitRatingAverage"
            :personalizedFitRatingAverage="fitGuidance?.fitRatingAverage"
            :barType="BAR_GRAPH_FIT"
            :fitBarWidth="'32px'"
            :class="{ 'u-spacer--2': fitGuidance?.fitRatingTotalCount }"
        />

        <div
            v-if="fitGuidance?.fitRatingAverage && fitGuidance?.fitRatingTotalCount"
            class="c-product-fit-slider-scale__legend"
        >
            <div class="c-product-fit-slider-scale__legend-item o-text--label u-text--gray">
                <span
                    :class="{
                        'c-product-fit-slider-scale__legend-item-color': true,
                        'c-product-fit-slider-scale__legend-item-color--personalized': true,
                    }"
                    aria-hidden="true"
                ></span>
                {{ t('reviews__fitGuidanceSlider--likeYouLegend', [fitGuidance?.fitRatingTotalCount]) }}
            </div>
            <div class="c-product-fit-slider-scale__legend-item o-text--label u-text--gray">
                <span
                    class="c-product-fit-slider-scale__legend-item-color"
                    aria-hidden="true"
                ></span>
                {{ t('reviews__fitGuidanceSlider--allLegend') }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { BAR_GRAPH_FIT } from '~modules/core/js/bar-graph-constants';
import BarGraph from '~modules/core/components/ui/BarGraph.vue';

defineProps({
    reviewSummary: {
        type: Object,
        required: true,
    },
    fitGuidance: {
        type: Object,
        required: true,
    },
});

const { t } = useI18n();
</script>

<style lang="scss">
.c-product-fit-slider-scale {
    &__legend {
        display: flex;
        width: 100%;
        gap: $nu-spacer-3;
    }

    &__legend-item {
        display: flex;
        gap: $nu-spacer-1;
        align-items: center;
    }

    &__legend-item-color {
        display: block;
        width: $nu-spacer-1;
        height: $nu-spacer-1;
        border-radius: 50%;
        background-color: $nu-primary;

        &:before {
            content: '';
        }

        &--personalized {
            background-color: $nu-personalized-100;
        }
    }
}
</style>
